import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

const When = ({ when }) => {
  let whenStatus = when && moment.utc(when).format('DD/MM/YYYY [às] HH[h]mm')
  return (
    <p className='txt-subtitle pt-half'>
      {whenStatus !== null && `em ${whenStatus}`}
    </p>
  )
}

When.propTypes = {
  when: PropTypes.string
}

export default When



// WEBPACK FOOTER //
// ./src/App/Header/Tracking/Item/Status/When.js